module.exports = __webpack_public_path__ + "static/media/lai-ali-express.e9955a5d.png";